module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_133857947109127.09f384a6.jpg";